import { render } from "./UserData.vue?vue&type=template&id=3789b0ef&scoped=true"
import script from "./UserData.vue?vue&type=script&lang=ts"
export * from "./UserData.vue?vue&type=script&lang=ts"

import "./UserData.vue?vue&type=style&index=0&id=3789b0ef&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3789b0ef"

export default script